export enum MicrophoneState {
  Pending, // We don't know the microphone state yet.
  Enabled, // The microphone is enabled. We can start recording.
  Disabled // The microphone is disabled because the user didn't grant us permissions.
}

export const RecordingActionTypes = {
    SetMicrophoneStateAction: "RECORDING_SET_MICROPHONESTATE",
    SetRecorderReadyAction: "RECORDING_SET_READY",
    SetRecorderIsPaused: "RECORDING_SET_ISPAUSED",
    SetRecordingDone: "RECORDING_DONE",
    RevertStateAction: "RECORDING_REVERT_STATE",
    SetWarningDismissedAction: "RECORDING_SET_WARNING_DISMISSED",
    SetPrivacyDisclaimerClosed: "RECORDING_SET_PRIVACY_DISCLAIMER_CLOSED",
    SetMicrophonePermissionRetryDialog: 'RECORDING_MICROPHONE_PERMISSION_RETRY_DIALOG'
};